import type { ReactElement } from "react";
import ReactMarkdown from "react-markdown";

// eslint-disable-next-line react-refresh/only-export-components
export function renderGIBadge(text: string): ReactElement {
  // New format: {{gi:GI_VALUE:gl:GL_VALUE:level}}
  const newMatch = text.match(/\{\{gi:(\d+):gl:(\d+):(\w+)\}\}/);
  if (newMatch) {
    const [, giValue, glValue, level] = newMatch;
    return (
      <span className={`gi-pill gi-pill--${level || "medium"}`}>
        <span className="opacity-75">GI</span>
        <span className="font-bold">{giValue}</span>
        <span className="opacity-50">&middot;</span>
        <span className="opacity-75">GL</span>
        <span className="font-bold">{glValue}</span>
      </span>
    );
  }
  // Legacy format: {{gi:VALUE:level}}
  const legacyMatch = text.match(/\{\{gi:(\d+):(\w+)\}\}/);
  if (legacyMatch) {
    const [, value, level] = legacyMatch;
    return (
      <span className={`gi-pill gi-pill--${level || "medium"}`}>
        <span className="opacity-75">GI</span>
        <span className="font-bold">{value}</span>
      </span>
    );
  }
  // Fallback: plain code
  return <code className="bg-[#f0ece6] px-1.5 py-0.5 rounded text-text text-xs">{text}</code>;
}

/** Renders AI-generated markdown with GI badge support in code blocks */
export function AIContent({ content }: { content: string }) {
  return (
    <div className="prose prose-sm prose-tufte max-w-none prose-p:my-2 prose-ul:my-2 prose-li:my-0.5">
      <ReactMarkdown
        components={{
          code: ({ children }) => renderGIBadge(String(children)),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
